import { Directive, Input, OnChanges, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[lumAppLoader]',
})
export class AppLoaderDirective implements OnChanges {
  @Input()
  loading :boolean;

  @Input()
  classes :string;

  constructor(
    private el :ElementRef,
    private renderer :Renderer2,
  ) {}

  ngOnChanges() :void {
    if (this.loading) {
      this.classes.split(' ').forEach((cls) => {
        this.renderer.addClass(this.el.nativeElement, cls);
      });
    } else {
      this.classes.split(' ').forEach((cls) => {
        this.renderer.removeClass(this.el.nativeElement, cls);
      });
    }
  }
}

@Directive({
  selector: '[lumAppLoader]',
  standalone: true,
})
export class AppLoaderStandaloneDirective extends AppLoaderDirective {}
